import React from "react";
import Layout from "../../../component/Layout";
import TestHeader from "./TestHeader";
import teststep2 from "../../../images/Teststep2.png";
import { Link } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

const TestResult = () => {
  return (
    <Layout>
      <div className="relative h-full testbg pb-5  overflow-y-auto">
        <TestHeader />
        <div className="w-full max-w-2xl mx-auto px-5 pb-5">
          <div className="relative text-center mb-[30px]">
            <p className="text-white text-base font-normal">Test Results</p>
            <Link
              to="/teststep3"
              className="absolute left-0 top-1/2 -translate-y-1/2"
            >
              <ArrowL />
            </Link>
          </div>
          <div className="pt-[118px] pb-[95px]">
          <div
              style={{ width: 174, height: 174 }}
              className="mx-auto mb-[30px]"
            >
              <CircularProgressbar
                strokeWidth={5}
                value={97}
                text={`${99}%`}
                styles={buildStyles({
                  textColor: "#fff", // Text color
                  pathColor: "#00901E", // Progress path color
                  trailColor: "#454545", // Background path color
                })}
              />
            </div>
          </div>
          <Link to="/train" className="div">
            <button className="w-full max-w-2xl mx-auto rounded-[70px] text-white text-base font-normal uppercase px-6 py-[22px] border border-white hover:opacity-70">
              Start Training
            </button>
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default TestResult;

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#FFFEFF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
